// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"oe_a bhe_a bhe_x","FilterForm__vgroup":"oe_b bhe_rp"};